import React, {createRef} from 'react'
import useIsInViewport from './useIsInViewport';

const withIsInViewport = Component => (props, state) => {
    const refElemViewport = createRef(null)
    const isInViewport = useIsInViewport(refElemViewport)
    
    return <Component 
        isInViewport={isInViewport}
        refElemViewport={refElemViewport}
        {...props} 
    />
}

export default withIsInViewport